import React, { useEffect, useMemo, useState, useContext } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useHistory, useLocation } from "react-router-dom";
import IdTokenContext from "./IdTokenContext";

export default function AuthCallback() {
    const { isLoading, isAuthenticated, error, loginWithRedirect, logout } = useAuth0();
    const { clearIdToken } = useContext(IdTokenContext);

    const history = useHistory();
    const { search } = useLocation();

    const q = useMemo(() => new URLSearchParams(search), [search]);
    const qpError = q.get("error");
    const hasCode = q.has("code");

    const [stuckSeconds, setStuckSeconds] = useState(0);

    // If the login succeeded, leave /callback ASAP (and drop query params)
    useEffect(() => {
        if (!isLoading && isAuthenticated) {
            history.replace("/");
        }
    }, [isLoading, isAuthenticated, history]);

    // Timer to detect "stuck on code forever" scenarios
    useEffect(() => {
        if (!hasCode || isAuthenticated || isLoading || qpError) return;

        setStuckSeconds(0);
        const t = setInterval(() => setStuckSeconds((s) => s + 1), 1000);
        return () => clearInterval(t);
    }, [hasCode, isAuthenticated, isLoading, qpError]);

    const attemptedRef = React.useRef(false);

    useEffect(() => {
        if (attemptedRef.current) return;
        if (error || !hasCode || isLoading || isAuthenticated) return;

        attemptedRef.current = true;
        console.log("now login!",loginWithRedirect);
        loginWithRedirect({
            // authorizationParams: {
            //     prompt: "login",
            // },
            // appState: { returnTo: "/" },
        })
    }, [error, hasCode, isLoading, isAuthenticated]);

    // If Auth0 sent an error in the URL, show it (NO auto redirects)
    if (qpError) {
        return (
            <div style={{ padding: 24, textAlign: "center" }}>
                <h2>Access Denied</h2>
                {/* <div style={{ marginTop: 8, whiteSpace: "pre-wrap" }}>{msg}</div> */}

                <div >
                    {/* <button
                        className="btn btn-secondary"
                        onClick={() => {
                            clearIdToken?.();
                            logout({
                                logoutParams: {
                                    // go to a clean non-callback URL
                                    returnTo: window.location.origin + "/",
                                    // optional: attempt to clear upstream SSO
                                    federated: true,
                                },
                            })
                        }
                        }
                    >
                        Main Menu
                    </button> */}

                    <button
                        className="btn btn-primary"
                        onClick={() =>
                            loginWithRedirect({
                                authorizationParams: {
                                    prompt: "login",
                                },
                                appState: { returnTo: "/" },
                            })
                        }
                    >
                        Switch Account
                    </button>

                    {/* <button
                        className="btn btn-link"
                        onClick={() => {
                            // drop query params but stay on callback so you can click Log In elsewhere if needed
                            history.replace("/callback");
                        }}
                    >
                        Clear error
                    </button> */}
                </div>
            </div>
        );
    }

    // Success path: we have a code, the SDK should exchange it.
    // If this is stuck, offer a recovery path without looping.
    const showStuckHelp = hasCode && !isLoading && !isAuthenticated && stuckSeconds >= 6;

    return (
        <div style={{ padding: 24, textAlign: "center" }}>
            <h2>Completing login…</h2>

            {hasCode && (
                <div style={{ marginTop: 8, opacity: 0.8 }}>
                    Authorization code detected. Waiting for token exchange…
                </div>
            )}

            {!hasCode && (
                <div style={{ marginTop: 8, opacity: 0.8 }}>
                    No code in the URL. If you expected to log in, start login again.
                </div>
            )}

            {error && (
                <div style={{ marginTop: 12, color: "#b00020", whiteSpace: "pre-wrap" }}>
                    {error.message || String(error)}
                </div>
            )}

            {showStuckHelp && (
                <div style={{ marginTop: 16 }}>
                    <div style={{ marginBottom: 8, opacity: 0.9 }}>
                        Still not authenticated after {stuckSeconds}s. This usually means the code exchange failed
                        (redirect URI mismatch, wrong Auth0 app/tenant, or SDK misconfigured).
                    </div>

                    <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                        <button
                            className="btn btn-secondary"
                            onClick={() => {
                                clearIdToken?.();
                                logout({
                                    logoutParams: {
                                        returnTo: window.location.origin + "/",
                                        federated: true,
                                    },
                                })
                            }
                            }
                        >
                            Logout
                        </button>

                        <button
                            className="btn btn-primary"
                            onClick={() =>
                                loginWithRedirect({
                                    authorizationParams: {
                                        prompt: "login",
                                    },
                                    appState: { returnTo: "/" },
                                })
                            }
                        >
                            Switch Account
                        </button>

                        {/* <button
                            className="btn btn-link"
                            onClick={() => history.replace("/")}
                        >
                            Go home
                        </button> */}
                    </div>
                </div>
            )}
        </div>
    );
}